import { Horizontal } from '@gravitate-js/excalibrr'

type TemplateShift = 'am' | 'pm' | null | undefined
type TemplateProps = {
  maxDays?: number
  compact?: boolean
  value?: Array<TemplateShift>
}

// Helper functions to determine colors based on shift type
const getBackgroundColor = (type: TemplateShift) => {
  if (type === 'am') return 'var(--theme-warning)'
  if (type === 'pm') return 'var(--theme-color-1)'
  return 'var(--gray-100)'
}

const getBorderColor = (type: TemplateShift) => {
  if (type === 'am') return 'var(--theme-warning)'
  if (type === 'pm') return 'var(--theme-color-1)'
  return 'var(--gray-300)'
}

export function TemplatePreview({ value, compact = false, maxDays }: TemplateProps) {
  // Determine how many days to show
  const daysToShow = maxDays ? Math.min(maxDays, value?.length ?? 0) : value?.length

  if (!daysToShow) return null

  return (
    <Horizontal gap={compact ? 1 : 2} style={{ overflow: 'visible', marginLeft: compact ? 0 : 8 }}>
      {/* Only render one day indicator per day in the template */}
      {Array.from({ length: daysToShow }).map((_, i) => {
        const shift = value?.[i]

        return (
          <div
            key={`shift:${i}-${shift}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              width: compact ? 6 : 8,
              height: compact ? 12 : 16,
            }}
          >
            {/* Only render one box that shows the shift type by color */}
            <div
              style={{
                height: compact ? 10 : 14,
                backgroundColor: getBackgroundColor(shift),
                border: `1px solid ${getBorderColor(shift)}`,
                borderRadius: '2px',
              }}
            />
          </div>
        )
      })}
    </Horizontal>
  )
}
